import React, { useEffect } from "react";
import { ItemFile } from "../../../../store/viewmodels/ItemFileViewModel";
import { getFileElement } from "../../../../utils/TaskContentServices";
import { getCardColors, getCardSize, getMessage } from "./CardUtilities";
import './MemoryGameStyles.css';

export interface CardProps {
    index: number,
    itemId: number,
    file: ItemFile,
    background: ItemFile | undefined,
    flippedCount: number,
    setFlippedCount: React.Dispatch<React.SetStateAction<number>>,
    flippedIndexes: { index: number, side: string }[],
    setFlippedIndexes: React.Dispatch<React.SetStateAction<{ index: number, side: string }[]>>,
    setScore: React.Dispatch<React.SetStateAction<number>>,
    score: number,
    matchedIndexes: number[];
    level: number,
    feedBack: JSX.Element,
    setFeedBack: React.Dispatch<React.SetStateAction<JSX.Element>>,
    turn: boolean,
    side: string,
    hideMatched: boolean
}

export function Card(props: CardProps) {
    const [flipped, set] = React.useState(false);
    const [matchedCss, setMatchedCss] = React.useState("");

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (props.turn) {
            if (props.matchedIndexes.indexOf(props.index) < 0) {
                set(prev => false);
            }
        }
    })

    useEffect(() => {
        if (props.matchedIndexes.includes(props.index)) {
            setMatchedCss("matched");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.hideMatched])

    if (props.file === undefined) {
        return <div>Tehtävässä on virhe</div>;
    }

    function setMessage(message: JSX.Element) {
        props.setFeedBack(message)
        setTimeout(() => {
            props.setFeedBack(prev => <></>);
        }, 1000);
    }

    const onCardClick = () => {
        if (flipped) {
            let message: JSX.Element = getMessage("alreadyClickedThis");
            setMessage(message);
        }
        else if (props.flippedIndexes.length === 2) {
            let message: JSX.Element = getMessage("alreadyTwoFlipped");
            setMessage(message);
        }
        else if (props.flippedIndexes.length > 0 && props.flippedIndexes[0].side === props.side) {
            let message = getMessage("sameSide");
            setMessage(message);
        }
        else if (props.flippedIndexes.length === 0 && props.side !== "right") {
            let message = getMessage("rightSideFirst");
            setMessage(message);
        }
        else {
            props.setScore(props.score + 1);
            set(true);
            props.setFlippedCount(props.flippedCount + 1);
            const newIndexes = [...props.flippedIndexes];
            let cardInfo = { index: props.index, side: props.side };
            newIndexes.push(cardInfo);
            props.setFlippedIndexes(newIndexes);
        }
    }

    let bgElement: JSX.Element = props.background === undefined ? <></> : getFileElement(props.background);
    let fileElement = getFileElement(props.file);
    
    let pathSplitted: string[] = props.file?.file?.split('.');
    let fileExtension = pathSplitted[pathSplitted.length - 1];
    let cardSize = getCardSize(props.level);
    
    let colors = matchedCss === "" ? getCardColors(fileExtension) : "border-gray-500 bg-gray-500";
    let disabled = matchedCss === "" ? "" : "pointer-events-none";

    return (
        <div className={`flip ${flipped ? "flipped" : ""}` + cardSize + " block box-border text-center justify-center " + disabled} onClick={() => onCardClick()}>
            <div className={"flip-content w-full h-full text-center justify-center"}>
                <div className={"flip-front " + colors + " absolute rounded-2xl border-4 lg:border-8 text-center justify-center overflow-hidden h-full w-full color-white "}>
                    {matchedCss === "" ? bgElement:  <></>}
                </div>
                <div className={matchedCss + " flip-back " + colors + " absolute rounded-2xl border-0 text-center justify-center overflow-hidden h-full w-full color-white "}>
                    <button className={""} >
                        {fileElement}
                    </button>
                </div>
            </div>
        </div>
    );
}